export enum ProductVersion {
    NOT_BOOKED = 'NOT_BOOKED',
    EMANAGER_S = 'EMANAGER_S',
    EMANAGER_M = 'EMANAGER_M',
}
